import { memo, useEffect, useMemo } from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';

import styled from '@mint-lib/styled';

import { DimensionsDragType } from '../EditModal.constants.js';
import { DraggableDimension } from '../EditModal.types.js';
import { mapDragTypeToDragLayer } from './mapDndTypeToDragLayer.jsx';

const DragLayer = () => {
  const { item, currentOffset, isDragging } = useDragLayer<{
    item: DraggableDimension | null;
    currentOffset: XYCoord | null;
    isDragging: boolean;
  }>((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const name = useMemo(() => {
    if (!item) {
      return '';
    }

    if (item.type === DimensionsDragType.SELECT_OPTION) {
      return item.name;
    } else {
      return item.dimension?.name;
    }
  }, [item]);

  useEffect(() => {
    if (item && Object.values(DimensionsDragType).includes(item.type)) {
      document.body.style.cursor = 'move';
    }

    return () => {
      document.body.style.cursor = 'auto';
    };
  }, [isDragging, item]);

  if (
    !item ||
    !isDragging ||
    !currentOffset ||
    !Object.values(DimensionsDragType).includes(item.type)
  ) {
    return null;
  }

  return (
    <Wrapper>
      {mapDragTypeToDragLayer[item.type]({
        name: String(name),
        currentOffset,
        isNumericOption: Boolean(item.isNumericOption),
      })}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  user-select: none;
  pointer-events: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export default memo(DragLayer);
